import { orchestrator } from 'satcheljs';
import { loadCalendarCache } from '../actions/internalActions';
import { initializeCalendarsCache } from 'owa-calendar-cache';

orchestrator(loadCalendarCache, () => {
    initializeCalendarsCache('AgendaPane');
});
